import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../auth/guard.ts'
import { NAV_PATHS } from '../navigation/paths.ts'
import { parseOneOf } from './params.ts'
import { rootRoute } from './root.tsx'

/** The one value the preview's search param takes. A tuple, so the type derives from it. */
export const PROFILE_VIEWS = ['public'] as const

export interface MyPlayerSearch {
  /** The preview: this same page asked for as a reader from outside reads it. Optional
   *  rather than nullable, because a `null` here would be serialised as `?as=null`. */
  readonly as?: (typeof PROFILE_VIEWS)[number]
}

// The giocatore's profile, also open to `parent`: a tutore looks at it through their
// child's eyes, one at a time, and the child switcher decides which.
export const myPlayerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/me/player',
  staticData: { opensOnHero: true },
  validateSearch: (search: Record<string, unknown>): MyPlayerSearch => {
    const view = parseOneOf(PROFILE_VIEWS, search.as)
    return view === null ? {} : { as: view }
  },
  beforeLoad: ({ context, location }) =>
    guardRoute({
      queryClient: context.queryClient,
      requiredRoles: ['player', 'parent'],
      currentPath: location.href,
    }),
  component: lazyRouteComponent(() => import('../pages/my-player.tsx')),
})

/** The profile, and the profile seen as a reader from outside sees it: the search param
 *  belongs to this route, so no page respells it. */
export const myPlayerLink = { to: NAV_PATHS.myPlayer, search: {} } as const

export const myPlayerPreviewLink = { to: NAV_PATHS.myPlayer, search: { as: 'public' } } as const
